export enum SendResultsTo {
  EMAIL = 'EMAIL',
  MOBILE = 'MOBILE',
}
